import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import {OtifFiltro} from '../content/pages/components/paineis/nivel-servico-logistico/modelo.model';

@Injectable({ providedIn: 'root' })
export class NivelServicoLogisticoService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/nivelServicoLogistico';
  }

  getVisao(otifFiltro: OtifFiltro) {
    return this.post('/visao', {
		dados: otifFiltro
	});
  }

	gerarRelatorioOtif(filtros: OtifFiltro) {
		return this.gerarRelatorioBody(this.getUrlRecurso() + '/gerar', filtros);
	}
}
